import axios from 'axios'
import * as R from 'ramda'

const extractMetadata = doc => {
  console.log('iframe extractMetadata')

  const metaTags = doc.querySelectorAll('meta[property^="og:"]')
  const meta = {}

  metaTags.forEach(tag => {
    const property = tag.getAttribute('property')
    const content = tag.getAttribute('content')
    if (property && content) {
      meta[property] = content
    }
  })

  console.log('metaTags!!!!', metaTags)

  const result = {
    title:       meta['og:title'] || meta['twitter:title'],
    description: meta['og:description'] || meta['twitter:description'],
    image:       meta['og:image'] || meta['twitter:image'],
    site:        meta['og:site_name'] || meta['twitter:site'],
  }

  if (!result.title && !result.description && !result.image && !result.site) {
    throw new Error('No OpenGraph or Twitter metadata found')
  }

  return result
}

export function getMetadataViaIframe(url) {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe')
    // iframe.style.display = 'none'
    iframe.sandbox = 'allow-same-origin allow-scripts'
    iframe.src = url

    const cleanup = () => {
      console.log('iframe cleanup')
      if (iframe.parentNode) {
        // iframe.parentNode.removeChild(iframe)
      }
    }

    const getDoc = () => {
      console.log('iframe getDoc')

      console.log('iframe', iframe)
      console.log(
        'R.path([\'contentDocument\'], iframe)',
        R.path(['contentDocument'], iframe)
      )
      console.log(
        'R.path([\'contentWindow\', \'document\'], iframe)',
        R.path(['contentWindow', 'document'], iframe)
      )
      const doc =
        R.path(['contentDocument'], iframe) ||
        R.path(['contentWindow', 'document'], iframe)
      if (!doc) {
        throw new Error('No document access - blocked by same-origin policy')
      }
      return doc
    }

    const timeout = setTimeout(() => {
      console.log('iframe timeout was called')
      try {
        const metadata = extractMetadata(getDoc())
        cleanup()
        resolve(metadata)
      } catch (e) {
        console.log('iframe timeout error', e)
        cleanup()
        reject(
          new Error('Iframe loading timed out after 5 seconds: ' + e.message)
        )
      }
    }, 5000)

    iframe.onload = () => {
      console.log('iframe.onload was called')
      try {
        const metadata = extractMetadata(getDoc())
        clearTimeout(timeout)
        cleanup()
        resolve(metadata)
      } catch (e) {
        console.log('iframe.onload error', e)
        clearTimeout(timeout)
        cleanup()
        reject(e)
      }
    }

    // iframe.onerror = () => {
    //   clearTimeout(timeout)
    //   cleanup()
    //   reject(new Error('Iframe failed to load the URL'))
    // }

    document.body.appendChild(iframe)
  })
}

async function fetchOgTags(link) {
  const response = await axios.get(link)
  const html = response.data

  const parser = new window.DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const metadata = extractMetadata(doc)

  return metadata
}

export async function fetchOgTags__or__getMetadataViaIframe(link) {
  return fetchOgTags(link)
  // try {
  //   return await fetchOgTags(link)
  // } catch (e) {
  //   return getMetadataViaIframe(link)
  // }
}

export async function postAddStoryPage_throttled_implementation(
  postAddStoryPage,
  postAddStoryPageWithMetadata,
  link
) {
  try {
    const metadata = await fetchOgTags__or__getMetadataViaIframe(link)
    const params = {
      url: link,
      ...metadata,
    }
    console.log('AddStory: postAddStoryPageWithMetadata -> ', params)
    postAddStoryPageWithMetadata(params)
  } catch (e) {
    console.error('AddStory: fetchOgTags failed -> ', e)
    console.log('AddStory: postAddStoryPage -> ', link)
    postAddStoryPage(link)
  }
}
